import { render, staticRenderFns } from "./CmgPillSelector.vue?vue&type=template&id=2c51bf22&scoped=true&lang=pug"
import script from "./cmg-pill-selector.ts?vue&type=script&lang=ts&external"
export * from "./cmg-pill-selector.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPillSelector.vue?vue&type=style&index=0&id=2c51bf22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c51bf22",
  null
  
)

export default component.exports